export default __webpack_public_path__ + "locales/en/InviteDialog.json?hash=4760c9d84a1a2edcfe08118455092349";